<template>
  <v-dialog fullscreen persistent :value="showDialog" transition="dialog-bottom-transition">
  <v-card>
      <v-toolbar dark color="primary">
        <v-toolbar-title>New Holiday Request</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="$emit('closeNewRequestDialog')">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-container class="text-xs-center">
        <v-layout row wrap>
          <v-flex xs12 class="mb-3">
            <div class="datepicker-trigger">
                <div class="text-xs-left">
                  <div class="mt-3 text-xs-left">
                    <h3><strong>Requested Dates: </strong></h3>
                  </div>
                  <div id="datepicker-trigger" class="text-xs-left">{{dateOne ? formatDates(dateOne, dateTwo) : 'Please select dates for you request'}}</div>
                  
                    <!-- holiday type selection dropbox -->
                    <v-layout classs="mt-3" row wrap v-if='canEditHolType == "1" && !dateConfirmed'>
                    <v-flex xs12 sm6>
                      <v-select v-model="holiday_type" :items="holidayTypes" label="Select A Holiday Type"></v-select>
                    </v-flex>
                    </v-layout> 

                  <div v-if="dateConfirmed && company !== 'lfp'" class="text-xs-left">{{hour}}:{{minute}} - {{filteredEndShiftTime}}:{{minute}}<span v-if="halfDay"> - (Half Day)</span></div>
                  <!-- current period start and end dates -->
                  <div style="display: inline-block; margin-right: 5px;" class="mt-3 text-xs-left">
                    <h3><strong>Current Period:</strong></h3>
                    <h1>{{holAllowance.period_start|formatDate('DD/MM/YYYY')}} - {{holAllowance.period_end|formatDate('DD/MM/YYYY')}}</h1>
                  </div>
                  <!-- next period start and end dates -->
                  <div style="display: inline-block;" class="mt-3 text-xs-left">
                    <h3><strong>Next Period:</strong></h3>
                    <h1 class="subtitle-1">{{holAllowance.period_start|formatNextHolPrdDate('DD/MM/YYYY')}} - {{holAllowance.period_end|formatNextHolPrdDate('DD/MM/YYYY')}}</h1>
                  </div>
                </div>
                <AirbnbStyleDatepicker  v-if="!dateConfirmed" :trigger-element-id="'datepicker-trigger'" :mode="'range'" :date-one="dateOne"
                :date-two="dateTwo" @date-one-selected="val => { dateOne = val }" @date-two-selected="val => { dateTwo = val }"
                inline :showActionButtons="false" :showShortcutsMenuTrigger="false" />
            </div>
            <v-layout row v-if="dateConfirmed && !detailsConfirmed">
              <template v-if="workerType == '0' && company !== 'lfp'">
                <v-container>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <div class="text-xs-left">
                        <h5><strong>This will be your normal shift start time</strong></h5>
                      </div>
                    </v-flex>
                    <v-flex xs2>
                      <v-select v-model="hour" :items="allowedHours"></v-select>
                    </v-flex>
                    <v-flex xs1>
                      <h1 style="font-size:44px">:</h1>
                    </v-flex>
                    <v-flex xs2>
                      <v-select v-model="minute" :items="allowedMinutes"></v-select>
                    </v-flex>
                  </v-layout>
                </v-container>
              </template>
            </v-layout>
            <v-layout row v-if="dateConfirmed && !detailsConfirmed">
              <v-container xs12 v-if="showHalfDay === '1'">
                <v-layout row>
                  <v-flex sm6>
                    <v-switch ml2 v-model="halfDay" inset label="Half Day"></v-switch>
                  </v-flex>
                  <v-flex sm6>
                    <v-switch ml2 :disabled="!halfDay" v-if="workerType != '0'" v-model="halfDayPM" inset label="Afternoon"></v-switch>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-layout>
            <v-layout style="display: flex; flex-direction: column;" v-if="dateConfirmed && detailsConfirmed">
              <!-- area for message if there is enough days -->
              <div id="enoughDaysForHoliday" style="margin-top: 10px;">
                <h4 ><strong style="color: #008900" v-if="!isButtonDisabled && this.whitelistedDates.length > 0 && this.selectedDateNextPeriodBeforeRelease !== 1">You Have Enough Holiday Allowance For The Holiday Request</strong></h4>
              </div>
              <!-- area for message if there is not enough days -->
              <div id="notEnoughDaysForHoliday">
                <h4 ><strong style="color: #EE0000" v-if="isButtonDisabled && this.whitelistedDates.length > 0 && this.selectedDateNextPeriodBeforeRelease !== 1">Not Enough Holiday Allowance For Holiday Request</strong></h4>
              </div>
              <!-- area for message if there is no days selected -->
              <div id="noDaysSelected">
                <h4 ><strong style="color: #D54200" v-if="this.whitelistedDates.length === 0 && this.selectedDateNextPeriodBeforeRelease !== 1">No Holiday Days Selected</strong></h4>
              </div>
              <!-- area for message if there are next period days selected when not reached the threshold -->
              <div id="noNextPeriodDaysSelected">
                <h4 ><strong style="color: #D54200" v-if="this.selectedDateNextPeriodBeforeRelease === 1">You are not allowed to request an absence for the Next Period before {{ this.dateOfThresholdForNextPeriod }}.</strong></h4>
              </div>
              <!-- section for displaying the days left -->
              <div v-if="this.whitelistedDates.length > 0 && this.selectedDateNextPeriodBeforeRelease !== 1" :style="{ 'border': 'solid 2px', 'border-color': getBorderColour(), 'border-radius': '4px' }">
                <div v-if="this.subTotalDays > 0" style="margin-top: 16px;">
                <p>Holiday Type: <strong>{{ holidayTypeText }}</strong></p>
                <p>Total days wanted from current period: <strong>{{ this.subTotalDays }}</strong></p>
                <p>Days remaining of current period:
                  <strong v-if="this.subTotalDays > 0 && (enoughDaysForHolidayThisYear === false && this.whitelistedDates.length > 0)" style="border-color: #EE0000;">{{ this.holAllowance.total_days_left }}</strong>
                  <strong v-if="this.subTotalDays > 0 && (enoughDaysForHolidayThisYear === true && this.whitelistedDates.length > 0)" style="border-color: #008900;">{{ this.holAllowance.total_days_left }}</strong>
                </p>
                <div v-if="this.holAllowance.currentLieuAllowance > 0">
                <p>Lieu days remaining for current period: <strong>{{ this.holAllowance.currentLieuAllowance }}</strong></p>
                </div>
                </div>
                <br>
                <div v-if="this.subTotalDaysNextYear > 0">
                <p>Total days wanted from next period: <strong>{{ this.subTotalDaysNextYear }}</strong></p>
                <p>Days remaining of next period:
                  <strong v-if="this.subTotalDaysNextYear > 0 && (enoughDaysForHolidayNextYear === false && this.whitelistedDates.length > 0)" style="border-color: #EE0000;">{{ this.holAllowance.total_next_period_days_left }}</strong>
                  <strong v-if="this.subTotalDaysNextYear > 0 && (enoughDaysForHolidayNextYear === true && this.whitelistedDates.length > 0)" style="border-color: #008900;">{{ this.holAllowance.total_next_period_days_left }}</strong>
                </p>
                <div v-if="this.holAllowance.nextLieuAllowance > 0">
                <p>Lieu days remaining for next period: <strong>{{ this.holAllowance.nextLieuAllowance }}</strong></p>
                </div>
                </div>
              </div>
              <div style="margin: 0px 0px 10px 0px;">
                <v-layout row>
                  <v-flex style="margin-top: 10px;">
                    <v-date-picker :allowed-dates="allowedWhitelistDate" v-model="whitelistedDates" multiple show-current="false" style="margin-top: 10px;"></v-date-picker>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex style="margin: 0px 0px 15px 0px;">
                    <h4>Please check the highlighted dates before submitting request</h4>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex style="margin: 0px 0px 15px 0px;">
                    <v-text-field v-model="requestComment" label="Add any notes or comments here"></v-text-field> 
                  </v-flex>
                </v-layout>
                
              </div>
            </v-layout>
            <v-layout v-if="gettingExistingRequests">
            <h3><strong>Fetching Existing Requests...</strong></h3>
            </v-layout>
            <v-layout row v-if="listOfSelectedDatesWithCounts.length > 0 && bookingThresholdSettingValue > 0">
              <div style="display:flex; flex-direction: column;">
              <h3 style="text-align:left"><strong>Other Employee Holidays On These Dates:</strong></h3>
                <ul style="text-align: left; padding-left: 0px; list-style-type: none;">
                  <li style="text-align: left;" v-for="item in listOfSelectedDatesWithCounts" 
                  :key="item.date" :style="{ color: (bookingThreshold !== -1 && bookingThreshold !== undefined && item.count >= bookingThreshold) ? '#EE0000' : '#008900' }"
                  >
                    <div style="display:flex; flex-direction: column; align-items: flex-start;">
                      <div>
                      <span style="display:inline-block; width:75px">{{ item.dayOfWeek }}</span>
                      <span style="display:inline-block; width:85px">{{ item.dateFormatted }}</span>
                      <span style="display:inline-block; width:85px"> - {{ item.count }} Booking{{ item.count === 1 ? '' : 's' }}</span>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </v-layout>
            <!--DATE-->
            <h3 style="text-align:left; color:#EE0000"  v-if="disableBtnForOtherBookings === true"><strong>There are too many existing bookings on some of the selected dates</strong></h3>
            
            <v-btn v-if="!dateConfirmed" color="primary" block class="mb-4" @click="dateConfirmed = true" :disabled="dateOne == '' || dateTwo == '' || disableBtnForOtherBookings || (bookingThresholdSettingValue > 0 && gettingExistingRequests == true)">Confirm Date Range</v-btn>
            <!--DETAILS-->
            <v-btn v-if="dateConfirmed && !detailsConfirmed" color="warning" block class="mb-4" @click="dateConfirmed = false" :disabled="loading">Edit Date Range</v-btn>
            <v-btn v-if="dateConfirmed && !detailsConfirmed" color="success" block class="mb-4" @click="detailsConfirmed = true" :disabled="loading">Submit Request Details</v-btn>
            <!--BLACKLIST-->
            <v-btn v-if="dateConfirmed && detailsConfirmed" color="warning" block class="mb-4" @click="detailsConfirmed = false" :disabled="loading">Edit Request Details</v-btn>
            <v-btn v-if="dateConfirmed && detailsConfirmed" color="success" block class="mb-4" @click="submitRequest()" :disabled="isButtonDisabled || selectedDateNextPeriodBeforeRelease === 1">Submit Holiday Request</v-btn>
          </v-flex>
          <v-flex xs12>
            <!-- <v-btn class="primary" :disabled="!dateOne" @click="submitRequest">Submit Request</v-btn> -->
          </v-flex>
        </v-layout>
        <Another-Holiday-Request-Dialog :showDialog="anotherRequest" @anotherRequest="anotherRequest = false" @returnToOverview="anotherRequest = false; $emit('closeNewRequestDialog')" class="mb-4"></Another-Holiday-Request-Dialog>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
  import format from 'date-fns/format'
  import moment from 'moment'
  import axios from 'axios'
  export default {
    props: ['showDialog', 'workerType', 'holAllowance', 'total_days_left', 'nextPeriodReleaseDays'],
    data () {
      return {
        url: this.$store.getters.url,
        dateFormat: 'Do MMMM',
        dateOne: '',
        dateTwo: '',
        length: 8,
        hour: this.company === 'lfp' ? '0' : '9',
        minute: '00',
        halfDay: false,
        halfDayPM: false,
        allowedHours: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'],
        allowedMinutes: ['00', '30'],
        user: this.$store.getters.user,
        company: this.$store.getters.company,
        dateConfirmed: false,
        detailsConfirmed: false,
        loading: false,
        anotherRequest: false,
        whitelistedDates: [],
        whitelistedDatesCurrentYear: [],
        whitelistedDatesNextYear: [],
        subTotalDays: 0,
        subTotalDaysNextYear: 0,
        currentLieuAllowance: this.holAllowance.currentLieuAllowance,
        nextLieuAllowance: this.holAllowance.nextLieuAllowance,
        curentyearholidays: 0,
        nextyearholidays: 0,
        enoughDaysForHolidayThisYear: false,
        enoughDaysForHolidayNextYear: false,
        empDetails: [],
        holidayTypes: [],
        holiday_type: -1,
        included_in_allowance: 1,
        canEditHolType: 0,
        showHalfDay: 0,
        requestComment: '',
        listOfSelectedDatesWithCounts: [],
        taSettings: [],
        bookingThreshold: -1,
        gettingExistingRequests: false,
        requestsDayCounts: {},
        hourRule: v => {
          if (!v.trim()) { return true }
          if (!isNaN(parseFloat(v)) && v >= 0 && v <= 23) return true
          return 'Value has to be a valid 24 hour time'
        },
        minuteRule: v => {
          if (!v.trim()) { return true }
          if (!isNaN(parseFloat(v)) && v === 0 && v === 30) return true
          return 'A shift can only start on the hour or half past the hour.'
        }
      }
    },
    computed: {
      dateOfThresholdForNextPeriod () {
        const nextPeriodStart = moment(this.holAllowance.period_start)
          .add(1, 'year')
          .startOf('day')
        const releaseDays = parseInt(this.nextPeriodReleaseDays, 10)
        let releaseDay = moment(nextPeriodStart).subtract(releaseDays, 'days')
        // Leap year adjustment: if a Feb 29 falls within [releaseDay, nextPeriodStart),
        // subtract one extra day so the date stays consistent across leap/non-leap years
        const startYear = releaseDay.year()
        const endYear = nextPeriodStart.year()
        for (let y = startYear; y <= endYear; y++) {
          const feb29 = moment(`${y}-02-29`, 'YYYY-MM-DD', true)
          if (feb29.isValid() && !releaseDay.isAfter(feb29) && nextPeriodStart.isAfter(feb29)) {
            releaseDay = releaseDay.subtract(1, 'day')
            break
          }
        }
        return releaseDay.format('DD/MM/YYYY')
      },
      disableBtnForOtherBookings () {
        const threshold = this.bookingThreshold
        return this.listOfSelectedDatesWithCounts.some(item => threshold !== -1 && threshold <= Number(item.count))
      },
      selectedDateNextPeriodBeforeRelease () {
        if (this.nextPeriodReleaseDays === '-1') {
          return 0
        } else {
          const nextPeriodStart = moment(this.holAllowance.period_start)
            .add(1, 'year')
            .startOf('day')
          const hasNextPeriodDates = this.nextyearholidays > 0
          if (!hasNextPeriodDates) return 0
          const releaseDays = parseInt(this.nextPeriodReleaseDays, 10)
          let releaseDay = moment(nextPeriodStart).subtract(releaseDays, 'days')
          // Leap year adjustment: if a Feb 29 falls within [releaseDay, nextPeriodStart),
          // subtract one extra day so the date stays consistent across leap/non-leap years
          const startYear = releaseDay.year()
          const endYear = nextPeriodStart.year()
          for (let y = startYear; y <= endYear; y++) {
            const feb29 = moment(`${y}-02-29`, 'YYYY-MM-DD', true)
            if (feb29.isValid() && !releaseDay.isAfter(feb29) && nextPeriodStart.isAfter(feb29)) {
              releaseDay = releaseDay.subtract(1, 'day')
              break
            }
          }
          const today = moment().startOf('day')
          return today.isBefore(releaseDay, 'day') ? 1 : 0
        }
      },
      holidayTypeText () {
        const matchingType = this.holidayTypes.find(type => type.value === this.holiday_type)
        return matchingType ? matchingType.text : 'Unknown'
      },
      filteredEndShiftTime () {
        if (((this.hour * 1) + this.length) < 24) {
          return ((this.hour * 1) + this.length)
        } else {
          return (((this.hour * 1) + this.length) - 24)
        }
      },
      isButtonDisabled () {
        return this.loading ||
        (this.subTotalDays > 0 && this.enoughDaysForHolidayThisYear === false) ||
        (this.subTotalDaysNextYear > 0 && this.enoughDaysForHolidayNextYear === false) ||
        this.whitelistedDates.length === 0
      },
      // Numeric value of the `booking_threshold` TA setting, or NaN when unset.
      bookingThresholdSettingValue () {
        const setting = this.taSettings && this.taSettings.booking_threshold
        return setting ? Number(setting.value) : NaN
      }
    },
    created () {
      this.getRegularDays()
      this.getHolidayTypes()
      this.getCompanyEditHolTypeSetting()
      this.getHalfDaySetting()
      this.getTASettings()
    },
    methods: {
      getTASettings () {
        axios.post(this.url + `/tanda-service/getTASettings.ajax.php`, {company: this.company})
          .then(result => {
            if (result.data) {
              this.taSettings = result.data
              this.bookingThreshold = Number(this.taSettings['booking_threshold_prevent_booking'].value)
            } else {
              this.taSettings = []
            }
          })
      },
      allowedWhitelistDate (val) {
        if (moment(val).isBetween(this.dateOne, this.dateTwo, undefined, '[]')) {
          return true
        }
        return false
      },
      formatNextHolPrdDate (date, format) {
        return moment(date).add(1, 'year').format(format)
      },
      formatDates (dateOne, dateTwo) {
        let formattedDates = ''
        if (dateOne) {
          formattedDates = format(dateOne, this.dateFormat)
        }
        if (dateTwo && dateTwo !== dateOne) {
          formattedDates += ' - ' + format(dateTwo, this.dateFormat)
        }
        return formattedDates
      },
      submitRequest () {
        this.loading = true
        const obj = {fname: this.user.fname, sname: this.user.sname, empID: this.user.empID, period_start: this.holAllowance.period_start, period_end: this.holAllowance.period_end, start: this.dateOne, end: this.dateTwo, hour: this.hour, minute: parseInt(this.minute), length: this.length, company: this.company, date_requested: moment().format('YYYY-MM-DD HH:mm:ss'), whitelisted_days: this.whitelistedDates, holiday_type: this.holiday_type, holiday_type_text: this.holidayTypeText, included_in_allowance: this.included_in_allowance, request_comment: this.requestComment}
        axios.post(this.url + `/tanda-service/saveEmpHolRequest.ajax.php`, obj)
          .then(result => {
            if (result && result.data && result.data.status === 'OK') {
              this.loading = false
              this.$emit('requestSubmitted', obj)
              this.anotherRequest = true
              this.dateOne = ''
              this.dateTwo = ''
              this.dateConfirmed = false
              this.detailsConfirmed = false
              this.whitelistedDates = []
              this.holiday_type = -1
              this.included_in_allowance = 1
              this.requestComment = ''
              // sending the email for the holiday request
              axios.post(this.url + `/tanda-service/sendEmailOnRequestToEmailAddress.ajax.php`, obj)
                .catch(e => {
                  console.log(e)
                })
            } else {
              this.loading = false
              this.$emit('requestSubmitted', obj)
              this.anotherRequest = true
              this.dateOne = ''
              this.dateTwo = ''
              this.dateConfirmed = false
              this.detailsConfirmed = false
              this.whitelistedDates = []
              this.holiday_type = -1
              this.included_in_allowance = 1
              this.requestComment = ''
              alert(result.data.message)
            }
          })
      },
      getHolidayTypes () {
        axios.post(this.url + `/tanda-service/getHolidayTypes.ajax.php`, {
          company: this.company
        })
          .then(response => {
            this.holidayTypes = response.data.map(item => ({
              text: item.holiday_type,
              value: item.ID,
              included_in_allowance: item.included_in_allowance
            }))
          })
          .catch(e => {
            console.log(e)
          })
      },
      getCompanyEditHolTypeSetting () {
        axios.post(this.url + `/tanda-service/getHolidayEditSetting.ajax.php`, {
          company: this.company
        })
          .then(response => {
            this.canEditHolType = response.data[0].value
          })
          .catch(e => {
            console.log(e)
          })
      },
      getHalfDaySetting () {
        axios.post(this.url + `/tanda-service/getHalfDaySetting.ajax.php`, {
          company: this.company
        })
          .then(response => {
            this.showHalfDay = response.data[0].value
          })
          .catch(e => {
            console.log(e)
          })
      },
      getRegularDays () {
        axios.post(this.url + `/tanda-service/getRegularWorkDays.ajax.php`, {
          company: this.company,
          empID: this.user.empID
        })
          .then(response => {
            this.empDetails = response.data
            console.log(response.data)
            // initialise the whitelistedDates based on regular work days
            this.adjustWhiteListedDatesForRegularDays()
          })
          .catch(e => {
            console.log(e)
          })
      },
      adjustWhiteListedDatesForRegularDays () {
        // Clear the array if details are not confirmed
        if (!this.detailsConfirmed) {
          this.whitelistedDates = []
        }
        const startDate = moment(this.dateOne)
        const endDate = moment(this.dateTwo)
        while (startDate.isSameOrBefore(endDate)) {
          const dayOfWeek = startDate.format('ddd').toLowerCase()
          const isRegular = this.empDetails.length > 0 && this.empDetails[0][dayOfWeek] === 1
          if (isRegular) {
            this.whitelistedDates.push(startDate.format('YYYY-MM-DD'))
          }
          startDate.add(1, 'day')
        }
      },
      calculateOtherVariables () {
        const currentYearStart = moment(this.holAllowance.period_start)
        const currentYearEnd = moment(this.holAllowance.period_end)

        // Filter the whitelistedDates based on whether they are in the current year
        const currentYearDates = this.whitelistedDates.filter(date => {
          const currentDate = moment(date)
          return currentDate.isBetween(currentYearStart, currentYearEnd, null, '[]')
        })

        // Filter the whitelistedDates based on whether they are in the next year
        const nextYearDates = this.whitelistedDates.filter(date => {
          const currentDate = moment(date)
          const nextYearStart = currentYearStart.clone().add(1, 'year')
          const nextYearEnd = currentYearEnd.clone().add(1, 'year')
          return currentDate.isBetween(nextYearStart, nextYearEnd, null, '[]')
        })

        this.curentyearholidays = currentYearDates.length
        this.nextyearholidays = nextYearDates.length
        this.subTotalDaysCalc()

        if (this.canEditHolType === '0') {
          // if the company does not allow the user to edit the holiday type use allowance AND Lieu allowance
          if (this.holAllowance.total_days_left + this.holAllowance.currentLieuAllowance - this.subTotalDays < 0) {
            this.enoughDaysForHolidayThisYear = false
          } else if ((this.holAllowance.total_days_left + this.holAllowance.currentLieuAllowance - this.subTotalDays >= 0)) {
            this.enoughDaysForHolidayThisYear = true
          }
          // if theres exactly enough days or more than enough days next period allow submit, else dont allow submit
          if (this.holAllowance.total_next_period_approved_days_left + this.holAllowance.nextLieuAllowance - this.subTotalDaysNextYear < 0) {
            this.enoughDaysForHolidayNextYear = false
          } else if ((this.holAllowance.total_next_period_approved_days_left + this.holAllowance.nextLieuAllowance - this.subTotalDaysNextYear >= 0)) {
            this.enoughDaysForHolidayNextYear = true
          }
        }
        // if the company allows the user to edit the holiday type use individual allowances
        if (this.canEditHolType === '1') {
          if (this.included_in_allowance === 0) {
            this.enoughDaysForHolidayThisYear = true
          }
          if (this.included_in_allowance === 1) {
            // if theres exactly enough days or more than enough days in current period allow submit, else dont allow submit
            if (this.holAllowance.total_days_left - this.subTotalDays < 0) {
              this.enoughDaysForHolidayThisYear = false
            } else if ((this.holAllowance.total_days_left - this.subTotalDays >= 0)) {
              this.enoughDaysForHolidayThisYear = true
            }
            // if theres exactly enough days or more than enough days next period allow submit, else dont allow submit
            if (this.holAllowance.total_next_period_approved_days_left - this.subTotalDaysNextYear < 0) {
              this.enoughDaysForHolidayNextYear = false
            } else if ((this.holAllowance.total_next_period_approved_days_left - this.subTotalDaysNextYear >= 0)) {
              this.enoughDaysForHolidayNextYear = true
            }
          }
          if (this.included_in_allowance === 2) {
            // if theres exactly enough days or more than enough days in current period allow submit, else dont allow submit
            if (this.holAllowance.currentLieuAllowance - this.subTotalDays < 0) {
              this.enoughDaysForHolidayThisYear = false
            } else if ((this.holAllowance.currentLieuAllowance - this.subTotalDays >= 0)) {
              this.enoughDaysForHolidayThisYear = true
            }
            // if theres exactly enough days or more than enough days next period allow submit, else dont allow submit
            if (this.holAllowance.nextLieuAllowance - this.subTotalDaysNextYear < 0) {
              this.enoughDaysForHolidayNextYear = false
            } else if ((this.holAllowance.nextLieuAllowance - this.subTotalDaysNextYear >= 0)) {
              this.enoughDaysForHolidayNextYear = true
            }
          }
        }
      },
      updateWhitelistedDates () {
        const dateDiff = moment(this.dateTwo).diff(this.dateOne, 'days')
        const outputCurrentYear = []
        const outputNextYear = []
        let updatedWhitelistedDates = []
        const currentYearStart = moment(this.holAllowance.period_start)
        const currentYearEnd = moment(this.holAllowance.period_end)
        const nextYearStart = moment(this.holAllowance.period_start).add(1, 'year')
        const nextYearEnd = moment(this.holAllowance.period_end).add(1, 'year')
        const allDaysZero = this.empDetails.length > 0 && Object.values(this.empDetails[0]).every(value => value === 0)
        for (let index = 0; index < dateDiff + 1; index++) {
          const currentDate = moment(this.dateOne).add(index, 'days')
          const formattedDate = currentDate.format('YYYY-MM-DD')
          if (
            this.empDetails.length === 0 ||
            this.areRegularDaysAllowed(currentDate)
          ) {
            // Check if the date is in the current year or the next year
            const dateYear = currentDate
            if (dateYear >= currentYearStart && dateYear <= currentYearEnd) {
              outputCurrentYear.push(formattedDate)
            } else if (dateYear >= nextYearStart && dateYear <= nextYearEnd) {
              outputNextYear.push(formattedDate)
            }
            updatedWhitelistedDates.push(formattedDate)
          }
        }
        // If all days are 0, use the full picked range
        if (allDaysZero) {
          updatedWhitelistedDates = Array.from({ length: dateDiff + 1 }, (_, index) =>
            moment(this.dateOne).add(index, 'days').format('YYYY-MM-DD')
          )
        }
        this.whitelistedDatesCurrentYear = outputCurrentYear
        this.whitelistedDatesNextYear = outputNextYear
        this.whitelistedDates = updatedWhitelistedDates
        this.calculateOtherVariables()
      },

      areRegularDaysAllowed (date) {
        const dayOfWeek = date.format('ddd').toLowerCase()
        return this.empDetails.length > 0 && this.empDetails[0][dayOfWeek] === 1
      },
      subTotalDaysCalc () {
        if (this.length === 8) {
          this.subTotalDays = this.curentyearholidays
          this.subTotalDaysNextYear = this.nextyearholidays
        } else if (this.length === 4) {
          this.subTotalDays = this.curentyearholidays / 2
          this.subTotalDaysNextYear = this.nextyearholidays / 2
        }
      },
      getBorderColour () {
        // logic to determine the border colour for the prompt on final screen of holiday request
        if (this.isButtonDisabled) {
          return '#EE0000' // Red
        } else if (!this.isButtonDisabled && this.whitelistedDates.length > 0) {
          return '#008900' // Green
        } else {
          return '#D54200' // Orange
        }
      },
      getExistingRequestsCount () {
        const threshold = this.bookingThresholdSettingValue
        if (!(threshold > 0)) {
          this.requestsDayCounts = {}
          this.gettingExistingRequests = false
          return Promise.resolve()
        }
        this.gettingExistingRequests = true
        return axios.post(this.url + `/tanda-service/getEmpHolRequestsCount.ajax.php`, {empID: this.user.empID, company: this.company, startDate: this.dateOne, endDate: this.dateTwo})
          .then(result => {
            if (result.data && typeof result.data === 'object' && !Array.isArray(result.data)) {
              this.requestsDayCounts = result.data
            } else {
              this.requestsDayCounts = {}
            }
          })
          .catch(e => {
            console.log(e)
            this.requestsDayCounts = {}
          })
          .then(() => {
            this.gettingExistingRequests = false
          })
      },
      updateSelectedDatesWithCounts: async function () {
        if (!this.dateOne || !this.dateTwo) {
          this.listOfSelectedDatesWithCounts = []
          return
        }
        await this.getExistingRequestsCount()
        if (!(this.bookingThresholdSettingValue > 0)) {
          this.listOfSelectedDatesWithCounts = []
          return
        }
        // API wraps the day->count map under a `dates` property, so unwrap if present
        let counts = this.requestsDayCounts || {}
        if (counts.dates !== undefined) {
          counts = counts.dates
        }
        // Normalise both shapes into an array of { date, count }
        let entries = []
        if (Array.isArray(counts)) {
          entries = counts.map(item => ({
            key: item.date || item.day || item.Date,
            count: item.count !== undefined ? item.count : item.value
          }))
        } else if (counts && typeof counts === 'object') {
          entries = Object.keys(counts).map(key => ({ key, count: counts[key] }))
        }
        if (entries.length === 0) {
          this.listOfSelectedDatesWithCounts = []
          return
        }
        const dateOne = moment(this.dateOne).startOf('day')
        const dateTwo = moment(this.dateTwo).startOf('day')
        if (!dateOne.isValid() || !dateTwo.isValid()) {
          this.listOfSelectedDatesWithCounts = []
          return
        }
        const startDate = moment.min(dateOne, dateTwo)
        const endDate = moment.max(dateOne, dateTwo)
        const selectedDates = []
        entries.forEach(entry => {
          if (!entry.key) {
            return
          }
          let requestDate = moment(entry.key, ['YYYY-MM-DD', 'YYYY-MM-DD HH:mm:ss', 'DD/MM/YYYY', moment.ISO_8601], false)
          if (!requestDate.isValid()) {
            requestDate = moment(entry.key)
          }
          if (!requestDate.isValid()) {
            return
          }
          if (
            requestDate.isSameOrAfter(startDate, 'day') &&
            requestDate.isSameOrBefore(endDate, 'day')
          ) {
            selectedDates.push({
              date: requestDate.format('YYYY-MM-DD'),
              dateFormatted: requestDate.format('DD/MM/YYYY'),
              dayOfWeek: requestDate.format('dddd'),
              count: Number(entry.count)
            })
          }
        })
        selectedDates.sort((a, b) => moment(a.date).diff(moment(b.date)))
        this.listOfSelectedDatesWithCounts = selectedDates
      }
    },
    watch: {
      dateOne: function () {
        this.updateSelectedDatesWithCounts()
      },
      dateTwo: function () {
        this.updateSelectedDatesWithCounts()
      },
      'halfDay': function () {
        if (this.halfDay) {
          this.length = 4
        } else {
          this.length = 8
          this.halfDayPM = false
        }
      },
      'halfDayPM': function () {
        if (this.halfDayPM) {
          this.hour = 13
        } else {
          this.hour = 9
        }
      },
      'detailsConfirmed': function () {
        this.updateWhitelistedDates()
      },
      'whitelistedDates': function () {
        this.calculateOtherVariables()
      },
      'holiday_type': function () {
        const selectedHolidayType = this.holidayTypes.find(item => item.value === this.holiday_type)
        if (selectedHolidayType) {
          this.included_in_allowance = selectedHolidayType.included_in_allowance
        }
      }
    },
    filters: {
      filterTime (val) {
        if (val === 24) {
          return 0
        }
        return val
      },
      formatDate (date, format) {
        return moment(date).format(format)
      },
      formatNextHolPrdDate (date, format) {
        return moment(date).add(1, 'year').format(format)
      },
      filterActionText (val) {
        if (val === 0) {
          return 'Pending'
        } else if (val === 1) {
          return 'Approved'
        } else if (val === 2) {
          return 'Declined'
        } else if (val === 3) {
          return 'Cancellation Requested'
        } else if (val === 5) {
          return 'Holiday Deleted'
        }
      },
      formatTime (val) {
        let startTimestamp = moment('1970-01-01 ' + ((val.hour * 1) < 10 ? '0' + val.hour : val.hour) + ':00').add(val.minute, 'minutes').format('h:mma')
        let endTime = (val.hour + val.length) > 24 ? (val.hour + val.length) - 24 : (val.hour + val.length)
        let endTimestamp = moment('1970-01-01 ' + (endTime) + ':00').add(val.minute, 'minutes').format('h:mma')
        // return val.hour * 1 + '    1970-01-01 ' + ((val.hour * 1) < 10 ? '0' + val.hour : val.hour) + ':00'
        return startTimestamp + ' - ' + endTimestamp
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/NewHolidayRequestDialog.vue